<template>
  <v-app-bar app extension-height="320" color="third" :class="[{'disable':loading},'sticky top-0']" style="z-index: 30;">
    <template v-if="showExtension" #extension>
      <div class="d-flex justify-center z2" style="width:100%;">
        <v-date-picker
          :max="maxDate"
          :min="minDate"
          :picker-date.sync="currentPickerDate"
          no-title
          :allowed-dates="allowedDates"
          :first-day-of-week="1"
          @input="onDayClick"
        />
      </div>
    </template>
    <v-app-bar-nav-icon :disabled="loading" color="white" @click="changeDrawerState()">
      <v-badge
        v-if="showFiltersBadge"
        color="#FFA500"
        :content="activeFiltersCount"
        offset-x="12"
        offset-y="10"
      >
        <v-icon>mdi-menu</v-icon>
      </v-badge>
      <v-icon v-else>mdi-menu</v-icon>
    </v-app-bar-nav-icon>
    <div v-if="!isInstructorMobile" style="width:100%;height:64px;" class="d-flex align-center gap-4">
      <v-btn text @click="homepage()">
        <v-img alt="UCPA" class="shrink" contain :src="require('@/assets/ucpa.svg')" width="100" />
      </v-btn>
      <v-btn outlined color="white" @click="today()">
        Aujourd’hui
      </v-btn>
      <v-btn icon color="white" @click="changeDay(-1)">
        <v-icon size="32" color="white">mdi-chevron-left</v-icon>
      </v-btn>
      <h3 class="pointer white--text text-no-wrap" @click="changeDrawerState()">{{ currentDate }}</h3>
      <v-btn icon color="white" @click="changeDay(1)">
        <v-icon size="32" color="white">mdi-chevron-right</v-icon>
      </v-btn>
      <SearchBar />

      <!-- <TopFilter /> -->
      <v-spacer />

      <DailyNotifications />

      <workspaces />
      <!-- <v-btn
        outlined
        dark
        @click="changeToCustomerPage"
      >
        Customers
        <v-icon right dark>mdi-wallet-travel</v-icon>
      </v-btn> -->
      <ActionPicker />
    </div>
    <div v-else class="d-flex" style="width:100%;height:100%;">
      <v-col v-if="isSessionDetailRoute" cols="2">
        <v-btn icon small @click="returnToHome">
          <v-icon color="white">mdi-arrow-left</v-icon>
        </v-btn>
      </v-col>
      <v-col cols="5" class="d-inline-block pa-0 mx-auto">
        <h3 class="white--text full-height text-center">
          <v-btn plain class="white--text pa-0 full-height" style="height: 100%" @click="clickDate">
            {{ currentMonth }}
            <div v-if="!isSessionDetailRoute">
              <v-icon v-if="!showExtension">mdi-chevron-down</v-icon>
              <v-icon v-else>mdi-chevron-up</v-icon>
            </div>
          </v-btn>
        </h3>
      </v-col>
      <v-col cols="5" class="d-inline-block text-center pa-0 ml-2" style="border: 1px solid white;">
        <div class="white--text subtitle-2 full-height d-flex align-center justify-center">{{ currentWorkspace.name }}</div>
      </v-col>
    </div>
    <UserInfo />
  </v-app-bar>
</template>

<script>
import { computed, ref, inject } from '@vue/composition-api';
import { format, add, parseISO, set } from 'date-fns';
import { fr } from 'date-fns/esm/locale';
import router from '@/router';

import SearchBar from './SearchBar.vue';
import { EventBus, isSameWeek, isSameMonth } from '../../helpers/utils';
import { handleSessions } from '../../helpers/amplify';
import workspaces from './WorkspacesPicker.vue';
import ActionPicker from './ActionPicker.vue';
import UserInfo from '@/components/UserInfo';
import DailyNotifications from './DailyNotifications.vue';
import store from '@/store';

export default {
  components: { SearchBar, workspaces, UserInfo, ActionPicker, DailyNotifications },
  setup (_, context) {
    const loading = computed(() => store.state.loading);

    const selectedDate = computed(() => store.getters.selectedDate);

    const isInstructorMobile = computed(() => store.getters.isIntructorOnMobile);

    const currentWorkspace = computed(() => store.state.workspace);

    const showExtension = ref(false);

    const minDate = ref(format(add(new Date(), { months: -1 }), 'yyyy-MM-dd'));
    const maxDate = ref(format(add(new Date(), { years: 1 }), 'yyyy-MM-dd'));

    const sessionsAgenda = computed(() => store.getters.instructorSessions);
    const currentMonth = inject('currentMonth');
    const currentPickerDate = inject('currentPickerDate');

    const clickDate = () => {
      showExtension.value = !showExtension.value;
    };

    const isSessionDetailRoute = computed(() => context.root.$route.name === 'SessionDetail');

    const homepage = () => {
      if (context.root.$route.path !== '/') {
        router.push({ path: '/' });
      }
    };

    const changeWeekLoadData = async () => {
      store.commit('setLoading', true);
      await handleSessions();
      store.commit('setLoading', false);
    };

    const changeMonthLoadData = async () => {
      store.commit('setLoading', true);
      await store.dispatch('allMonthlySessions', 'horses');
      store.commit('setLoading', false);
    };

    const today = async () => {
      if (format(new Date(), 'yyyy-MM-dd') !== format(new Date(parseISO(selectedDate.value)), 'yyyy-MM-dd')) {
        const sameWeek = isSameWeek(format(new Date(), 'yyyy-MM-dd'));
        const sameMonth = isSameMonth(format(new Date(), 'yyyy-MM-dd'));
        store.commit('setSelectedDate', format(new Date(), 'yyyy-MM-dd'));
        if (!sameWeek) {
          await changeWeekLoadData();
        }

        if (!sameMonth) {
          await changeMonthLoadData();
        }
      }
      homepage();
    };

    const changeDay = async amount => {
      const newDate = format(add(parseISO(selectedDate.value), { days: amount }), 'yyyy-MM-dd');
      const sameWeek = isSameWeek(newDate);
      const sameMonth = isSameMonth(newDate);
      store.commit('setSelectedDate', newDate);
      if (!sameWeek) {
        await changeWeekLoadData();
      }
      if (!sameMonth) {
        await changeMonthLoadData();
      }
    };

    const currentDate = computed(() => format(parseISO(selectedDate.value), 'dd MMMM yyyy', { locale: fr }));

    const changeDrawerState = () => {
      EventBus.$emit('changeDrawerState');
    };

    const currentTab = computed(() => store.state.currentTab);
    const sidebarOpen = computed(() => store.state.sidebarOpen);
    const activeFiltersCount = computed(() => store.getters.activeRepriseFiltersCount);
    const showFiltersBadge = computed(() =>
      currentTab.value === 'reprise' && !sidebarOpen.value && activeFiltersCount.value > 0
    );

    const changeToCustomerPage = () => {
      router.push({ path: '/customers' });
    };

    const returnToHome = () => {
      showExtension.value = false;
      document.location.href = `/#month_${format(set(new Date(), { date: 1 }), 'yyyy-MM-dd')}`;
    };

    const allowedDates = date => (sessionsAgenda.value.days.some(day => day === date) ? date : null);

    const onDayClick = date => {
      document.location.href = `#${date}`;
      showExtension.value = false;
    };

    return { minDate, maxDate, currentPickerDate, currentMonth, onDayClick, allowedDates, sessionsAgenda, isSessionDetailRoute, changeToCustomerPage, loading, homepage, today, changeDay, currentDate, changeDrawerState, isInstructorMobile, currentWorkspace, clickDate, showExtension, returnToHome, showFiltersBadge, activeFiltersCount };
  }
};
</script>
